<footer class="container">
    <div class="footer-inner">
        <div class="footer-inner__logo"></div>

        <div class="footer-inner__navigation">
            <div class="footer-inner__navigation__list">
                <h6>Navigation</h6>
                <ul>
                    <li><a routerLink="/">Cryptocurrencies</a></li>
                    <li>
                        <a routerLink="/gainers-losers">Gainers & Losers</a>
                    </li>
                </ul>
            </div>

            <div class="footer-inner__navigation__list">
                <h6>Socials</h6>
                <ul>
                    <li>
                        <a href="https://facebook.com" target="_blank"
                            >Facebook</a
                        >
                    </li>
                    <li>
                        <a href="https://web.telegram.org/" target="_blank"
                            >Telegram</a
                        >
                    </li>
                    <li>
                        <a href="https://instagram.com" target="_blank"
                            >Instagram</a
                        >
                    </li>
                    <li>
                        <a href="https://twitter.com" target="_blank"
                            >Twitter</a
                        >
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <p class="copyright">© 2021 CoinMarketCap. All rights reserved</p>
</footer>
